<template>
    <i class="icon"
       :class="MenuIconTypes[icon].value" />
</template>

<script setup lang="ts">
    import { INavigationItem } from '../../types/menuTypes';
    import { MenuIconTypeEnum } from '../../enums/menuEnums';

    defineProps<{
        icon: INavigationItem['icon'],
    }>();

    const MenuIconTypes = {
        [MenuIconTypeEnum.LIST]: {
            value: 'fa-solid fa-list',
        },
    } as const;
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/design-system/variables" as variables;

.icon {
    padding: 6px;
    border: 1px solid legacyVariables.$white;
    border-radius: 100%;
    background-color: variables.$error500;
    color: legacyVariables.$white;
}
</style>
